import Devices from '../components/views/device/Devices.vue'
import DeviceCreate from '../components/views/device/DeviceCreate.vue'
import DeviceDetail from '../components/views/device/DeviceDetail.vue'

const routes = [{
        path: 'device',
        component: Devices,
        name: 'Devices',
        meta: {
            description: 'List of Think Gas Devices',
            title: 'Devices',
            requiresAuth: true
        }
    },

    {
        path: 'device/create',
        component: DeviceCreate,
        name: 'DeviceCreate',
        meta: {
            description: 'Add a new device',
            title: 'Add Device',
            requiresAuth: true
        }
    },
    {
        path: '/device/:_id',
        beforeEnter: (to, from, next) => {
            to.params._id === 'create' ? next({ name: 'DeviceCreate' }) : next()
        },
        component: DeviceDetail,
        name: 'DeviceDetail',
        meta: {
            description: 'Details for the selected device',
            title: 'Update Device',
            requiresAuth: true
        }
    },
]

export default routes


// WEBPACK FOOTER //
// ./src/routes/devices.route.js